import React, {useState} from 'react';
import {Navigate, useNavigate, useSearchParams} from 'react-router-dom';
import {getCookie, isTokenValid, setCookie} from '../api';

const IDENTITY_URL = 'https://identity.intechweben.com/api/v1';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';
  const tenantName = getCookie('tenantName') ? decodeURIComponent(getCookie('tenantName')) : 'HCM Central';

  if (isTokenValid()) return <Navigate to={redirect} replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${IDENTITY_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, relm: 'matterking.com' }),
      });
      if (!res.ok) {
        setError('Invalid username or password');
        return;
      }
      const data = await res.json();
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
      setCookie('jwtToken', data.jwtToken, expires);
      setCookie('renewalToken', data.renewalToken, expires);
      setCookie('displayName', encodeURIComponent(data.displayName || ''), expires);
      navigate(redirect);
    } catch {
      setError('Unable to connect to login service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-indigo-600">{tenantName}</h1>
          <p className="text-gray-500 mt-2">Sign in to continue</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
            <input id="username" type="text" required value={username} onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none" />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 font-medium disabled:opacity-50">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
